import { combineEpics } from 'redux-observable'

import { api as enrichmentAPI } from './api'
import * as actions from './actions'
import { companyData as demoData } from './demodata'
import * as GateSelectors from 'app/modules/gates/selectors'
import { orgId } from 'app/modules/org/selectors'
import { companyData as localCompanyData, makeHasRequestedDecodedCondition } from "./selectors"
import { of } from 'rxjs/observable/of'
import { fromJS, Map } from 'immutable'
import { isEmpty } from 'lodash'
import { epic as demandbaseEpic } from './demandbase'

function parseEnrichment(data) {
  const tags = data.get('tags')
  const geo = data.get('geography')
  const tech = data.get('tech')

  return {
    name: data.get('name'),
    domain: data.get('domain'),
    logo: data.get('logo'),
    description: data.get('description'),
    linkedInHandle: data.getIn(['social', 'linkedin', 'handle']),
    twitterHandle: data.getIn(['social', 'twitter', 'handle']),
    employeeCount: data.getIn(['metrics', 'employees']),
    industry: data.getIn(['category', 'industry']),
    subIndustry: data.getIn(['category', 'subIndustry']),
    location: data.get('location'),
    madkuduScore: data.get('companyScore'),
    moneyRaised: data.getIn(['metrics', 'raised']),
    marketCap: data.getIn(['metrics', 'revenueRange']),
    geo: geo && geo.toJS(),
    tags: tags && tags.toJS(),
    url: data.get('url'),
    source: data.get('source'),
    tech: tech && tech.toJS(),
  }
}

const fetchLocal = (state, options) => {
  if (GateSelectors.hasDemoOrg(state)) {
    return fromJS(parseEnrichment(demoData))
  } else {
    return localCompanyData(state, options)
  }
}

const fetchRemote = (state, options) => {
  return enrichmentAPI.fetchEnrichedCompanyData(options)
    .map(data => hasEnrichmentResults(data) ? makeResponse(fromJS(parseEnrichment(data)), true) : makeResponse(data, false))
}

const makeResponse = (data, status) => {
  return { result: data, ok: status }
}

const getCompanyData = (state, options) => {
  return of(fetchLocal(state, options)).flatMap(result => result ? of(makeResponse(result, true)) : fetchRemote(state, options))
}


const fetchEnrichedCompanyData = (action$, { getState }) => {
  return action$
    .ofType(actions.fetchEnrichedCompanyData.toString())
    .pluck('payload')
    .mergeMap(options => {
      return getCompanyData(getState(), options)
        .takeUntil(action$.ofType(actions.fetchEnrichedCompanyDataCancelled({ email: options.email, ip: options.ip })))
        .map(data => {
          if (data.ok === true) {
            return actions.fetchEnrichedCompanyDataSuccess({ data: data.result, email: options.email, ip: options.ip, conversationId: options.conversationId })
          } else {
            return actions.fetchEnrichedCompanyDataNoResult({ email: options.email, ip: options.ip })
          }
        })
        .startWith(actions.fetchEnrichedCompanyDataPending({ email: options.email, ip: options.ip }))
        .catch(error => of(error).map(() => actions.fetchEnrichedCompanyDataFailed({ email: options.email, ip: options.ip })))
    })
}

const fetchDecodedCondition = (action$, { getState }) =>
  action$
    .ofType(actions.fetchDecodedCondition.toString())
    .pluck('payload')
    .mergeMap(({ conditions, ...rest }) => {
      const state = getState()
      const getHasRequestedDecodedCondition = makeHasRequestedDecodedCondition(state)
      return of({
        conditions: conditions.filter(condition => !getHasRequestedDecodedCondition(condition)),
        orgId: orgId(state),
        ...rest,
      })
    })
    .filter(({ conditions }) => conditions.length)
    .mergeMap(({ conditions, ip, orgId, enrichmentProvider }) => (
      enrichmentAPI.fetchDecodedCondition(enrichmentProvider, conditions, ip, orgId))
        .map(({ response }) => {
          const map = {}
          conditions.forEach((condition, i) => map[condition] = response[i])
          return actions.fetchDecodedConditionSuccess({ conditions: Map(map) })
        })
        .startWith(actions.fetchDecodedConditionPending({ conditions }))
        .catch(err => of(actions.fetchDecodedConditionFailed({ conditions, err })))
    )

const hasEnrichmentResults = (data) => {
  return data !== undefined
    && (!isEmpty(data.get('name')))
}

export const epic = combineEpics(
  fetchEnrichedCompanyData,
  fetchDecodedCondition,
  demandbaseEpic,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/epic.js